<div class="usage-bar-track"
     [class.usage-bar-track--square]="squareEnds"
     [class.usage-bar-track--static]="!clickable"
     [class.usage-bar-track--thin]="thin"
     [style.background]="gradientBackground"
     (click)="barClick.emit()"
     [matTooltip]="tooltip">
    <div class="usage-bar-mask" [style.left.%]="fillWidthPct"></div>
    <span class="usage-bar-label" [class.usage-bar-label--thin]="thin" [class.usage-bar-label--dark]="darkText">{{ displayPercent }}</span>
</div>
